function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "DropDown_svg__a",
  d: "M4.1 4.593l-.5-.495L0 .498.5 0l3.6 3.6L7.7 0l.494.495-3.6 3.6-.495.495z"
});

function SvgDropDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.195 4.596"
  }, props), _ref, _ref2);
}

export default SvgDropDown;